import store from './store'
export function init () {
  return new Promise(async (resolve) => {
    // 获取国家并存入store
    await store.dispatch('GET_COUNTRY')
    const { country } = store.state
    // 巴西使用99主题
    if (country === 'BR') {
      window.document.documentElement.setAttribute('data-theme', '99')
      import('./common/stylus/99-theme.styl')
      // 墨西哥使用didi主题
    } else if (country === 'MX') {
      window.document.documentElement.setAttribute('data-theme', 'didi')
      import('./common/stylus/didi-theme.styl')
      // 使用didi主题兜底
    } else {
      window.document.documentElement.setAttribute('data-theme', 'didi')
      import('./common/stylus/didi-theme.styl')
    }
    resolve()
  })
}
